export default {
  heading: 'Whisper, serif',
  body: 'Open Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Cinzel, serif',
  googleFonts: ['Open Sans:100,200,300,400,500,600,700,800,900', 'Whisper', 'Cinzel']
}
